var map = {
	"./distributionBoardImages-example.jpg": "804a",
	"./distributionBoardSchemaImages-example.jpg": "dad5",
	"./electricityMeterBoxImages-example.jpg": "f4fd",
	"./installationSiteImages-example.jpg": "3da3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8410";